import * as React from "react";
import MaskedInput, { MaskedInputProps } from "./MaskedInput";

interface OrganisasjonsnummerInputProps extends Omit<MaskedInputProps, "mask" | "unmask"> {
  mask?: MaskedInputProps["mask"];
}

const OrganisasjonsnummerInput: React.FC<OrganisasjonsnummerInputProps> = ({ mask = "000 000 000", ...rest }) => {
  return <MaskedInput {...rest} mask={mask} />;
};

export default OrganisasjonsnummerInput;
